export const sortObjectByKeys = (obj: {
  [key: string]: any;
}): { [key: string]: any } => {
  const sortedEntries: [string, any][] = Object.entries(obj).sort(([a], [b]) =>
    a.localeCompare(b)
  );
  return Object.fromEntries(sortedEntries);
};
